import { genareteInvoicePDF } from '../services/apiService';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { toast } from 'react-toastify';
import { createRoot } from 'react-dom/client';

export const generatePDFFromHTML = async (invoice) => {
    console.log("Generating PDF from React element...");
    try {
        // Step 1: Get React component from backend
        const invoiceElement = await genareteInvoicePDF(invoice.id);
        console.log("Invoice React element:", invoiceElement);

        // Step 2: Create hidden container
        const tempContainer = document.createElement("div");
        tempContainer.className = "invoice-temp-container";
        tempContainer.style.position = "absolute";
        tempContainer.style.left = "-9999px";
        tempContainer.style.top = "-9999px";
        tempContainer.style.width = "210mm";
        tempContainer.style.backgroundColor = "#ffffff";
        document.body.appendChild(tempContainer);

        // Step 3: Render React element into the container
        const root = createRoot(tempContainer);
        root.render(invoiceElement);

        // Step 4: Wait for React rendering & images/fonts
        await new Promise((resolve) => setTimeout(resolve, 1500));

        // Step 5: Capture the container as an image
        const canvas = await html2canvas(tempContainer, {
            scale: 2,
            useCORS: true,
            allowTaint: true,
            backgroundColor: "#ffffff",
        });

        // Step 6: Unmount and clean up
        root.unmount();
        document.body.removeChild(tempContainer);

        // Step 7: Generate PDF
        const pdf = new jsPDF("p", "mm", "a4");
        const pageWidth = 210;
        const pageHeight = 297;
        const imgWidth = pageWidth;
        const imgHeight = (canvas.height * pageWidth) / canvas.width;
        const imgData = canvas.toDataURL("image/png");

        if (imgHeight <= pageHeight) {
            // Content fits on one page - add it normally
            pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
        } else {
            // Content is too tall - scale it down to fit one page
            const scaledHeight = pageHeight;
            const scaledWidth = (canvas.width * pageHeight) / canvas.height;
            
            // Center the content horizontally if it's narrower than page width
            const xOffset = scaledWidth < pageWidth ? (pageWidth - scaledWidth) / 2 : 0;
            
            pdf.addImage(imgData, "PNG", xOffset, 0, scaledWidth, scaledHeight);
        }

        // Step 8: Save PDF
        pdf.save(`invoice-${invoice.id}.pdf`);
        toast.success("✅ PDF generated successfully!");
        return true;
    } catch (error) {
        console.error("Error generating PDF:", error);
        toast.error("❌ Failed to generate PDF");
        return false;
    }
};
